import {Component, HostListener} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {DailyReportsService} from '../../../services/daily-reports.service';
import {ConstantsService} from '../../../services/constants.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'daily-reports-list',
    templateUrl: './daily-reports-list.component.html',
    styleUrls: ['./daily-reports-list.component.scss']
})
export class DailyReportsListComponent {

    constructor(
        public urlService: UrlService,
        public dailyReportsService: DailyReportsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.dailyReportsService.data.allDailyReports.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.parcels-hint-td').length) {
            $('.parcels-hint-td').removeClass('active');
        }
    }

    close(report) {
        this.dailyReportsService.close(report);
    }

    toggleCheck(selectedItem): void {
        if(!this.dailyReportsService.entryTyped) {
            const checked = selectedItem.checked;
            this.dailyReportsService.data.allDailyReports.data.forEach(item => item.checked = false);
            if (checked && this.dailyReportsService.selectedItemData) {
                this.dailyReportsService.selectedItemData = null;
                this.dailyReportsService.toggleDetailedView(null, false);
                selectedItem.checked = false;
            } else {
                selectedItem.checked = true;
                this.dailyReportsService.selectedItemData = selectedItem;
                this.dailyReportsService.toggleDetailedView(selectedItem, true);
            }
        } else {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.dailyReportsService.entryTyped = false;
                    this.toggleCheck(selectedItem);
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/daily-reports/daily-reports-list/daily-reports-list.component.ts